import { useContext } from "react";
import Page from "src/components/Report/Page";
import { logoPath } from "src/config";
import jobContext from "src/context/jobContext";
import { getJalaliSeasonYear } from "src/utils/getJalaliSeasonYear";

export default function Page1() {
    const { job } = useContext(jobContext)
    let baseInfo
    let jobTitle = job.title;
    let vazayefOmoomi;
    let vahedSazmani;
    let orgName;
    if (localStorage.baseInfo) {
        baseInfo = JSON.parse(localStorage.baseInfo)
        jobTitle = baseInfo.jobTitle ?? job.title;
        vahedSazmani = baseInfo.vahedSazmani;
        orgName = baseInfo.orgName;
    }
    if (localStorage.vazayefOmoomi) {
        vazayefOmoomi = JSON.parse(localStorage.vazayefOmoomi);
    }
    let vazayefNumber = 0;






    return (
        <>
            {
                job.organization
                    ?
                    <Page isInnerPage={false}>
                        <div className="flex flex-col h-full justify-center items-center rounded gap-20 border-2 border-solid border-gray-800 ">
                            <img src={job.organization ? process.env.REACT_APP_API_URL + "/img/" + job.organization.logo : logoPath} className="w-[250px]" />
                            <h1 className="font-bold text-5xl text-gray-800 my-20">شناسنامه استاندارد مشاغل</h1>
                            <div className="relative w-full">
                                <div className="flex justify-center relative z-[2] items-center text-white font-bold text-4xl h-[120px] w-full bg-[#5b5cff]">
                                    {jobTitle}
                                </div>
                                <div className="absolute -top-10 translate-x-24 right-[50%] rounded-full w-[200px] h-[200px] bg-gray-100 scale-x-[400%] scale-y-125"></div>
                                <div className="absolute -top-10 left-[50%] -translate-x-10 font-bold text-gray-700">عنوان شغل:</div>
                                <div className="absolute -bottom-10 left-[50%] -translate-x-10 font-bold text-gray-700">شناسه : {parseInt(job.id) + 1000}</div>

                            </div>
                            <div className="flex flex-col items-center gap-6 font-semibold text-lg text-gray-800 mt-10">
                                <span className="text-gray-800">واحد سازمانی:</span>
                                <span className="text-gray-800 text-2xl">{job.orgUnit}</span>
                                <span className="text-gray-800">{orgName}</span>
                            </div>
                            {/* <div className="flex h-[100px] w-full" style={{ direction: "ltr" }}> */}
                                <div className="w-[40%] flex flex-col items-center justify-center text-lg p-4 gap-2 text-gray-700 bg-gray-50 rounded-full">
                                    <span>شبکه جامع مشاغل</span>
                                    <span className="font-bold text-xl">www.jobonet.ir</span>
                                </div>
                                <div className="flex flex-col bg-[#fab402] rounded-lg w-fit">

                                    <div className="w-fit p-2 h-full flex justify-center items-center">
                                        <span className="text-gray-800 font-medium flex justify-center items-center">{getJalaliSeasonYear()}</span>
                                    </div>

                                </div>
                            {/* </div> */}
                        </div>
                    </Page>
                    :
                    < Page isInnerPage={false} >
                        
                    </Page >
            }
        </>


    )
}